//TODO: Remover agent cuando funcione agents
export const DEFAULT_FUNNELS_FILTERS = {
  amount: '',
  amount_condition: "eq",
  lead_status: [],
  start_created_at: null,
  end_created_at: null,
  start_expected_close_date: null,
  end_expected_close_date: null,
  agents: [],
  agent: 'all',
  included_tags: [[]],
  excluded_tags: [[]]
};
